import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";
import type { UserPermissions } from "common/types";

import type { ReactNode } from "react";

export default function RestrictedComponent({
  visibleForPermissions,
  enabledForPermissions,
  children,
}: {
  visibleForPermissions?: UserPermissions;
  enabledForPermissions?: UserPermissions;
  children: ReactNode | ((isDisabled: boolean) => ReactNode);
}) {
  const { permissions } = useSelectedWorkspaceContext();

  const isVisible =
    !visibleForPermissions ||
    visibleForPermissions.some((visibleForPermission) =>
      permissions.some((permission) => visibleForPermission === permission),
    );

  if (isVisible) {
    const isEnabled =
      !enabledForPermissions ||
      enabledForPermissions.some((enabledForPermission) =>
        permissions.some((permission) => enabledForPermission === permission),
      );
    return typeof children === "function" ? children(!isEnabled) : children;
  }
}
